export const style = {
    width: '100%',
    fontFamily: 'Roboto', // Roboto is more readable for financial data
    height: '100%',

    // --- tool panel styling ---
    '& .ag-tool-panel-wrapper': { width: '100%' },
    '& .ag-side-bar': { overflow: 'hidden' },
    '& .ag-column-panel': { flexDirection: 'row' },
    '& .ag-column-select': { flexGrow: 3 },
    '& .ag-column-drop': { flexGrow: 3 },
    '& .ag-column-drop-cell': { overflow: 'hidden' },
    '& .ag-column-drop-vertical': { maxHeight: 'unset' },
    // --- end tool panel styling ---

    // --- header styling ---
    '& .ag-header': {
        borderBottom: 'none',
        // remove the uppercase from header cells text
        textTransform: 'unset',
    },
    '& .ag-header-cell-label': { justifyContent: 'center' },
    '& .ag-header-cell': {
        paddingRight: '7px',
        paddingLeft: '7px',
    },
    '& .ag-header-row': {
        color: '#787878',
        fontSize: '12px',
        fontWeight: '500',
    },
    '& .ag-header-container': {
        borderBottom: '1px solid #ddd',
        borderLeft: '1px solid #ddd',
    },
    '& .ag-header-group-cell, & .ag-header-cell': {
        backgroundColor: '#f8f8f8',
        borderStyle: 'solid',
        borderWidth: '1px 1px 0 0',
        borderColor: '#ddd',
        '& .ag-header-group-text': {
            margin: 'auto', // center years in header
        },
    },
    // --- end header styling ---
    '& .ag-cell': {
        lineHeight: '32px',
        fontSize: '12px',
        textAlign: 'right', // financial data are align to the right
        color: '#313131',
        borderStyle: 'solid',
        borderWidth: '0 1px 1px 0',
        borderColor: '#eee !important',
        paddingRight: '7px',
        paddingLeft: '7px',
    },
    '& .ag-row': { border: 'none' },
    '& .ag-center-cols-container': { borderLeft: '1px solid #ddd' },
    '& .ag-group-expanded, & .ag-group-contracted': {
        // reduce margin a the right of the arrow to expand/fold lines
        marginRight: '2px !important',
        height: '34px !important',
    },
    '& .ag-group-value': {
        fontSize: '12px',
        fontWeight: '500',
    },
    '& .ag-row-footer': { fontWeight: 'bold' },
    // hiding field checkboxes: because the processPivotResultColDef callback is not called on checking / unchecking
    // this can lead to a display of the grid which is not up to date.
    // making checkboxes numb, checkboxes become solely an indicators whether or not the field is selected
    '& .ag-checkbox-input': {
        pointerEvents: 'none',
    },
    '& .ag-checkbox-input-wrapper': {
        pointerEvents: 'none',
        background: 'none',
    },
    '& .ag-checkbox': {
        opacity: '0.5',
    },
    '& .ag-icon-grip': {
        position: 'absolute',
        pointerEvents: 'auto',
        left: '10%', // to leave the closing cross out of the grabbing zone
        opacity: 0,
        margin: '-13px',
        width: '70%',
    },
};

/**
 * Optional styling to enable checkbox withing TCD.
 */
export const checkBoxEnabledStyle = {
    '& .ag-checkbox-input': {
        pointerEvents: 'auto',
    },
    '& .ag-checkbox-input-wrapper': {
        pointerEvents: 'auto',
    },
    '& .ag-checkbox': {
        opacity: '0.5',
        zIndex: 2,
    },
    '& .ag-icon-grip': {
        position: 'absolute',
        pointerEvents: 'auto',
        zIndex: 1,
        left: '10%',
        opacity: 0,
        margin: '-13px',
        width: '70%',
    },
};
